module.exports = __webpack_public_path__ + "img/closs.9b625f87.svg";